/**
 * @generated SignedSource<<39890d294c755583b46f2182f49c048e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraIssueLinkDirection = "BOTH" | "INWARD" | "OUTWARD" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type ui_IssueFieldLinkRelationshipInlineEditFull_LinkRelationshipInlineEditView_fieldRef$data = {
  readonly fieldId: string;
  readonly id: string;
  readonly issueLink: {
    readonly direction: JiraIssueLinkDirection | null | undefined;
    readonly id: string | null | undefined;
    readonly relationName: string | null | undefined;
    readonly type: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
  readonly name: string;
  readonly type: string;
  readonly " $fragmentSpreads": FragmentRefs<"ui_IssueFieldLinkRelationshipReadviewFull_LinkRelationshipTypeReadView">;
  readonly " $fragmentType": "ui_IssueFieldLinkRelationshipInlineEditFull_LinkRelationshipInlineEditView_fieldRef";
};
export type ui_IssueFieldLinkRelationshipInlineEditFull_LinkRelationshipInlineEditView_fieldRef$key = {
  readonly " $data"?: ui_IssueFieldLinkRelationshipInlineEditFull_LinkRelationshipInlineEditView_fieldRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_IssueFieldLinkRelationshipInlineEditFull_LinkRelationshipInlineEditView_fieldRef">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ui_IssueFieldLinkRelationshipInlineEditFull_LinkRelationshipInlineEditView_fieldRef",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "name": "fieldId"
    },
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "concreteType": "JiraIssueLink",
      "kind": "LinkedField",
      "name": "issueLink",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "name": "direction"
        },
        {
          "kind": "ScalarField",
          "name": "relationName"
        },
        {
          "concreteType": "JiraIssueLinkType",
          "kind": "LinkedField",
          "name": "type",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "ui_IssueFieldLinkRelationshipReadviewFull_LinkRelationshipTypeReadView"
    }
  ],
  "type": "JiraIssueLinkRelationshipTypeField"
};
})();

(node as any).hash = "9cfdc8201ada4d220c4623a0703ec8fb";

export default node;
